(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tct-breath-memory-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tct-pdp-memory-strip')) {
    customElements.define('tct-pdp-memory-strip', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.track = this.querySelector('[data-pdp-memory-track]');
        this.items = Array.from(this.querySelectorAll('[data-pdp-memory-item]'));
        this.dots = Array.from(this.querySelectorAll('[data-pdp-memory-dot]'));
        this.current = this.querySelector('[data-pdp-memory-current]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.frame = null;
        if (!this.track || !this.items.length) return;

        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updateActive();
          });
        };

        this.onScrollEnd = () => this.updateActive();

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('scrollend', this.onScrollEnd, { passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          this.goTo(Math.min(Math.max(this.activeIndex() + direction, 0), this.items.length - 1));
        });

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.pdpMemoryTarget)));
        });

        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('[data-pdp-memory-item]');
          if (item) this.goTo(Number(item.dataset.pdpMemoryIndex));
        });

        this.resizeObserver = new ResizeObserver(() => this.updateActive());
        this.resizeObserver.observe(this.track);
        this.updateActive();
      }

      activeIndex() {
        const trackLeft = this.track.getBoundingClientRect().left;
        let closest = 0;
        let distance = Infinity;
        this.items.forEach((item, index) => {
          const nextDistance = Math.abs(item.getBoundingClientRect().left - trackLeft);
          if (nextDistance < distance) {
            closest = index;
            distance = nextDistance;
          }
        });
        return closest;
      }

      updateActive() {
        this.setActive(this.activeIndex());
      }

      goTo(index) {
        const item = this.items[index];
        if (!item) return;
        const trackRect = this.track.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const left = this.track.scrollLeft + itemRect.left - trackRect.left;
        this.track.scrollTo({ left, behavior: this.reducedMotion ? 'auto' : 'smooth' });
        this.setActive(index);
      }

      setActive(index) {
        if (this.current) this.current.textContent = String(index + 1).padStart(2, '0');
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      disconnectedCallback() {
        if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
        if (this.track && this.onScrollEnd) this.track.removeEventListener('scrollend', this.onScrollEnd);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tct-conscious-map"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tct-conscious-map')) {
    customElements.define('tct-conscious-map', class TctConsciousMap extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('.tct-map__form');
        if (!this.form || this.querySelector('.tct-map__success')) return;
        this.screens = [...this.querySelectorAll('[data-map-screen]')];
        this.processing = this.querySelector('[data-map-processing]');
        this.current = 0;
        this.apiEndpoint = this.dataset.apiEndpoint || '';
        this.countrySelect = this.querySelector('select[name="contact[País ISO]"]');
        this.countryName = this.querySelector('input[name="contact[País]"]');
        this.classList.add('is-enhanced');
        this.querySelectorAll('[data-map-next]').forEach((button) => button.addEventListener('click', () => this.next()));
        this.querySelectorAll('[data-map-back]').forEach((button) => button.addEventListener('click', () => this.back()));
        if (this.countrySelect) this.countrySelect.addEventListener('change', () => this.updateCountryName());
        this.form.addEventListener('submit', (event) => this.submit(event));
        this.querySelector('[data-map-pdf]')?.addEventListener('click', () => this.track('tct_map_pdf_download'));
        this.querySelector('[data-map-result] a[href]:not([data-map-pdf])')?.addEventListener('click', () => this.track('tct_map_next_step_click'));
        this.claritySection = this.closest('.shopify-section')?.nextElementSibling;
        if (this.claritySection) {
          this.claritySection.classList.add('tct-clarity-application-section');
          this.claritySection.hidden = true;
          this.claritySection.addEventListener('submit', () => this.track('tct_clarity_application_submit'), true);
        }
        this.querySelectorAll('[data-clarity-open]').forEach((button) => button.addEventListener('click', () => this.openClarityApplication()));
        this.observeMapView();
      }

      disconnectedCallback() {
        if (this.pdfObjectUrl) URL.revokeObjectURL(this.pdfObjectUrl);
        this.mapViewObserver?.disconnect();
        this.clearProcessingTimers();
      }

      updateCountryName() {
        if (!this.countrySelect || !this.countryName) return;
        const option = this.countrySelect.options[this.countrySelect.selectedIndex];
        this.countryName.value = option?.dataset.countryName || '';
      }

      track(eventName, parameters = {}) {
        window.TCTAnalytics?.track?.(eventName, {
          map_step: this.current + 1,
          ...parameters
        });
      }

      observeMapView() {
        if (!('IntersectionObserver' in window)) {
          this.track('tct_map_view');
          return;
        }
        this.mapViewObserver = new IntersectionObserver((entries, observer) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.track('tct_map_view');
          observer.disconnect();
        }, { threshold: 0.25 });
        this.mapViewObserver.observe(this);
      }

      validateCurrent() {
        const controls = [...this.screens[this.current].querySelectorAll('input, textarea, select')];
        for (const control of controls) {
          if (!control.checkValidity()) {
            control.reportValidity();
            return false;
          }
        }
        return true;
      }

      show(index) {
        this.current = Math.max(0, Math.min(this.screens.length - 1, index));
        this.screens.forEach((screen, screenIndex) => { screen.hidden = screenIndex !== this.current; });
        this.screens[this.current].scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        const firstControl = this.screens[this.current].querySelector('textarea, input:not([type="hidden"]), button');
        if (firstControl) window.setTimeout(() => firstControl.focus({ preventScroll: true }), 260);
        this.track('tct_map_step_view', { step_name: this.screens[this.current]?.dataset.mapScreen || '' });
      }

      next() {
        if (!this.validateCurrent()) return;
        if (this.current === 0) this.track('tct_map_start');
        this.show(this.current + 1);
      }

      back() {
        this.show(this.current - 1);
      }

      openClarityApplication(source = 'map_result') {
        if (!this.claritySection) return;
        this.track('tct_clarity_application_open', { source });
        this.claritySection.hidden = false;
        this.claritySection.classList.add('is-visible');
        window.requestAnimationFrame(() => {
          this.claritySection.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          window.setTimeout(() => this.claritySection.querySelector('input, textarea, button, [tabindex]')?.focus({ preventScroll: true }), 480);
        });
      }

      clearProcessingTimers() {
        (this.processingTimers || []).forEach((timer) => window.clearTimeout(timer));
        this.processingTimers = [];
      }

      setProcessingStage(index) {
        this.querySelectorAll('[data-map-processing-stage]').forEach((stage, stageIndex) => {
          stage.classList.toggle('is-active', stageIndex === index);
          stage.classList.toggle('is-complete', stageIndex < index);
        });
      }

      showProcessing() {
        this.clearProcessingTimers();
        this.screens.forEach((screen) => { screen.hidden = true; });
        this.querySelector('[data-map-result]').hidden = true;
        this.processing.hidden = false;
        this.setProcessingStage(0);
        this.processingTimers = [
          window.setTimeout(() => this.setProcessingStage(1), 1500),
          window.setTimeout(() => this.setProcessingStage(2), 3400)
        ];
        this.processing.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }

      async submit(event) {
        if (!this.apiEndpoint) return;
        event.preventDefault();
        if (!this.validateCurrent()) return;
        const button = this.querySelector('[data-map-submit]');
        const originalText = button.textContent;
        this.querySelectorAll('.tct-map__message').forEach((message) => message.remove());
        this.updateCountryName();
        button.disabled = true;
        button.textContent = 'Creando tu mapa…';
        this.form.setAttribute('aria-busy', 'true');
        this.track('tct_map_submit', {
          session_interest: this.querySelector('input[name="contact[Interés en sesión uno a uno]"]')?.checked ? 'yes' : 'no'
        });
        this.showProcessing();
        try {
          const fields = {};
          new FormData(this.form).forEach((value, key) => { fields[key] = value; });
          const response = await fetch(this.apiEndpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ source: 'tct_tu_historia', fields })
          });
          if (!response.ok) throw new Error('map_request_failed');
          const data = await response.json();
          this.renderResult(data);
        } catch (error) {
          this.track('tct_map_error', { error_type: error?.message || 'unknown' });
          this.clearProcessingTimers();
          this.processing.hidden = true;
          button.disabled = false;
          button.textContent = originalText;
          this.show(this.screens.length - 1);
          const message = document.createElement('p');
          message.className = 'tct-map__message';
          message.setAttribute('role', 'alert');
          message.textContent = 'No pudimos crear tu mapa en este momento. Inténtalo de nuevo o escríbenos directamente.';
          button.closest('.tct-map__actions').after(message);
        } finally {
          this.form.removeAttribute('aria-busy');
        }
      }

      renderResult(data) {
        const result = this.querySelector('[data-map-result]');
        this.clearProcessingTimers();
        this.processing.hidden = true;
        this.screens.forEach((screen) => { screen.hidden = true; });
        const pdf = result.querySelector('[data-map-pdf]');
        pdf.hidden = true;
        if (this.pdfObjectUrl) {
          URL.revokeObjectURL(this.pdfObjectUrl);
          this.pdfObjectUrl = '';
        }

        if (data.status === 'support_required') {
          this.track('tct_map_support_required');
          this.querySelector('[data-clarity-invitation]')?.setAttribute('hidden', '');
          result.querySelector('[data-map-result-title]').textContent = 'Tu historia merece acompañamiento humano.';
          result.querySelector('[data-map-delivery-status]').textContent = 'En este caso no generamos ni enviamos un mapa automático. Lo más importante es que puedas encontrar apoyo humano ahora.';
          result.querySelector('[data-map-result-attention-heading]').textContent = 'Lo que ahora importa';
          result.querySelector('[data-map-result-attention]').textContent = data.message || '';
          result.querySelector('[data-map-result-choice-heading]').textContent = 'Apoyo inmediato';
          result.querySelector('[data-map-result-choice]').textContent = data.resources || '';
          result.querySelector('[data-map-result-step-heading]').textContent = 'Un primer paso';
          result.querySelector('[data-map-result-step]').textContent = 'Busca a una persona de confianza y evita atravesar este momento a solas.';
        } else {
          this.track('tct_map_complete', { email_delivery: data.delivery?.email?.status || 'unknown' });
          this.querySelector('[data-clarity-invitation]')?.removeAttribute('hidden');
          result.querySelector('[data-map-result-title]').textContent = 'Tu mapa está listo.';
          const delivery = result.querySelector('[data-map-delivery-status]');
          if (data.delivery?.email?.status === 'sent') {
            const email = this.querySelector('input[name="contact[email]"]')?.value || '';
            const maskedEmail = email.replace(/^(.{1,2}).*(@.*)$/, '$1•••$2');
            delivery.textContent = `También enviamos una copia a ${maskedEmail}. Puedes descargarla aquí como respaldo.`;
          } else {
            delivery.textContent = 'Tu mapa está disponible aquí. La copia por correo no pudo enviarse, así que descárgala ahora para conservarla.';
          }
          result.querySelector('[data-map-result-attention-heading]').textContent = 'Lo que hoy pide atención';
          result.querySelector('[data-map-result-attention]').textContent = data.lo_que_pide_atencion || '';
          result.querySelector('[data-map-result-choice-heading]').textContent = 'La elección que aparece';
          result.querySelector('[data-map-result-choice]').textContent = data.eleccion_que_aparece || '';
          result.querySelector('[data-map-result-step-heading]').textContent = 'Un primer paso posible';
          result.querySelector('[data-map-result-step]').textContent = data.primer_paso_posible || '';
        }

        if (data.pdf_base64) {
          const binary = window.atob(data.pdf_base64);
          const bytes = new Uint8Array(binary.length);
          for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
          this.pdfObjectUrl = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
          pdf.href = this.pdfObjectUrl;
          pdf.download = data.pdf_filename || 'mapa-consciente.pdf';
          pdf.hidden = false;
        } else if (data.pdf_url) {
          pdf.href = data.pdf_url;
          pdf.hidden = false;
          pdf.download = data.pdf_filename || 'mapa-consciente.pdf';
        }
        result.hidden = false;
        result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        window.setTimeout(() => result.focus({ preventScroll: true }), 260);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tct-home-collective"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tct-purpose')) {
    customElements.define('tct-purpose', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-purpose-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-purpose-panel]'));
        this.images = Array.from(this.querySelectorAll('[data-purpose-image]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
        this.activate(0, false);
      }

      activate(index, moveFocus = false) {
        this.dataset.purposeState = String(index);
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && moveFocus) tab.focus();
        });
        this.panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        if (this.images.length) {
          this.images.forEach((image, imageIndex) => image.classList.toggle('is-active', imageIndex === index));
        }
      }

      onKeydown(event, index) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        this.activate(next, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tct-home-manifesto"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tct-manifesto')) {
    customElements.define('tct-manifesto', class extends HTMLElement {
      connectedCallback() {
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.onScroll = this.update.bind(this);
        if (this.reduceMotion) {
          this.style.setProperty('--tct-manifesto-progress', '1');
          return;
        }
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      update() {
        const rect = this.getBoundingClientRect();
        const viewport = window.innerHeight || 1;
        const progress = Math.min(1, Math.max(0, (viewport - rect.top) / (viewport + rect.height * 0.45)));
        this.style.setProperty('--tct-manifesto-progress', progress.toFixed(3));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tct-home-newsletter"] && !Shopify.designMode) return;
  try {
    
  class TctNewsletterForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[data-tct-newsletter-submit]');
      this.successMessage = this.querySelector('[data-tct-newsletter-success]');
      this.handleSubmit = this.handleSubmit.bind(this);
      this.form?.addEventListener('submit', this.handleSubmit);

      if (this.successMessage) {
        window.requestAnimationFrame(() => this.successMessage.focus({ preventScroll: true }));
      }
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.handleSubmit);
    }

    handleSubmit() {
      if (!this.form?.checkValidity() || !this.submitButton) return;
      this.submitButton.dataset.tctState = 'loading';
      this.submitButton.setAttribute('aria-busy', 'true');
      this.submitButton.querySelector('[data-tct-newsletter-state="idle"]')?.setAttribute('aria-hidden', 'true');
      this.submitButton.querySelector('[data-tct-newsletter-state="loading"]')?.setAttribute('aria-hidden', 'false');
      queueMicrotask(() => { this.submitButton.disabled = true; });
    }
  }

  if (!customElements.get('tct-newsletter-form')) {
    customElements.define('tct-newsletter-form', TctNewsletterForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tct-home-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(pointer: fine)');

    const initMotion = (root = document) => {
      root.querySelectorAll('[data-tct-product-motion]').forEach((stage) => {
        if (stage.dataset.motionReady === 'true') return;
        stage.dataset.motionReady = 'true';

        const plane = stage.querySelector('[data-tct-product-plane]');
        const object = stage.querySelector('[data-tct-product-object]');
        if (!plane || !object || reducedMotion.matches) {
          stage.classList.add('is-visible', 'is-settled');
          return;
        }

        stage.classList.add('is-prepared');

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            stage.classList.add('is-visible');
            observer.unobserve(stage);
          });
        }, { threshold: 0.28, rootMargin: '0px 0px -8% 0px' });

        observer.observe(stage);

        object.addEventListener('animationend', (event) => {
          if (event.animationName === 'tctProductReveal') stage.classList.add('is-settled');
        }, { once: true });

        if (stage.dataset.pointerMotion !== 'true' || !finePointer.matches) return;

        let frame;
        stage.addEventListener('pointermove', (event) => {
          if (!stage.classList.contains('is-visible')) return;
          if (frame) cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const rect = stage.getBoundingClientRect();
            const x = (event.clientX - rect.left) / rect.width - 0.5;
            const y = (event.clientY - rect.top) / rect.height - 0.5;
            plane.style.setProperty('--tct-product-tilt-x', `${y * -3.2}deg`);
            plane.style.setProperty('--tct-product-tilt-y', `${x * 4.2}deg`);
          });
        });

        stage.addEventListener('pointerleave', () => {
          if (frame) cancelAnimationFrame(frame);
          plane.style.setProperty('--tct-product-tilt-x', '0deg');
          plane.style.setProperty('--tct-product-tilt-y', '0deg');
        });
      });
    };

    initMotion();
    document.addEventListener('shopify:section:load', (event) => initMotion(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tct-join-movement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.joinReady === 'true') return;
      root.dataset.joinReady = 'true';
      const tabs = Array.from(root.querySelectorAll('[data-join-route-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-join-route-panel]'));
      const form = root.querySelector('[data-join-form]');
      const roleSelect = root.querySelector('[data-join-role]');
      const tagsInput = root.querySelector('[data-join-tags]');
      const routeKeyInput = root.querySelector('[data-join-route-key]');
      const application = root.querySelector('.tct-join__application');
      const endpoint = root.dataset.apiEndpoint?.trim();
      const fallbackError = root.dataset.errorMessage || 'No pudimos recibir tu aplicación en este momento.';
      const fields = root.querySelector('[data-join-fields]');
      const transition = root.querySelector('[data-join-transition]');
      const success = root.querySelector('[data-join-success]');
      const errorMessage = root.querySelector('[data-join-error]');
      const submitButton = root.querySelector('[data-join-submit]');

      const activate = (key, moveFocus = false) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.joinRouteTab === key;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && moveFocus) tab.focus();
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.joinRoutePanel !== key; });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.joinRouteTab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const next = event.key === 'ArrowRight' ? (index + 1) % tabs.length : (index - 1 + tabs.length) % tabs.length;
          activate(tabs[next].dataset.joinRouteTab, true);
        });
      });

      root.querySelectorAll('[data-join-apply]').forEach((button) => {
        button.addEventListener('click', () => {
          const route = button.dataset.joinApply;
          if (roleSelect) {
            const option = Array.from(roleSelect.options).find((item) => item.dataset.routeKey === route);
            if (option) roleSelect.value = option.value;
          }
          if (tagsInput) tagsInput.value = `join_submitted,source_join_page,role_${route}`;
          if (routeKeyInput) routeKeyInput.value = route;
          application?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          window.setTimeout(() => roleSelect?.focus(), 450);
        });
      });

      roleSelect?.addEventListener('change', () => {
        const option = roleSelect.options[roleSelect.selectedIndex];
        if (tagsInput && option?.dataset.routeKey) tagsInput.value = `join_submitted,source_join_page,role_${option.dataset.routeKey}`;
        if (routeKeyInput && option?.dataset.routeKey) routeKeyInput.value = option.dataset.routeKey;
      });

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!form.reportValidity()) return;
        if (!endpoint) {
          if (errorMessage) {
            errorMessage.textContent = fallbackError;
            errorMessage.hidden = false;
            errorMessage.focus?.();
          }
          return;
        }
        if (errorMessage) {
          errorMessage.hidden = true;
          errorMessage.textContent = '';
        }
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
          submitButton.textContent = submitButton.dataset.processingLabel || submitButton.textContent;
        }
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const transitionStartedAt = performance.now();
        const wait = (duration) => new Promise((resolve) => window.setTimeout(resolve, duration));
        if (fields) fields.hidden = true;
        if (transition) {
          transition.classList.remove('is-completing');
          transition.hidden = false;
        }
        form.setAttribute('aria-busy', 'true');
        application?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        try {
          const formData = new FormData(form);
          const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'omit',
            body: JSON.stringify({ fields: Object.fromEntries(formData.entries()), route_key: routeKeyInput?.value || '' })
          });
          const result = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(result.message || fallbackError);
          const minimumDuration = reducedMotion ? 0 : 1400;
          const remainingDuration = Math.max(0, minimumDuration - (performance.now() - transitionStartedAt));
          if (remainingDuration) await wait(remainingDuration);
          if (transition && !reducedMotion) {
            transition.classList.add('is-completing');
            await wait(280);
          }
          if (transition) transition.hidden = true;
          if (success) success.hidden = false;
          const reference = root.querySelector('[data-join-reference]');
          const referenceWrap = root.querySelector('[data-join-reference-wrap]');
          if (reference && result.reference) {
            reference.textContent = result.reference;
            referenceWrap.hidden = false;
          }
          const delivery = root.querySelector('[data-join-delivery]');
          if (delivery) {
            delivery.textContent = result.delivery?.applicant?.status === 'sent'
              ? root.dataset.successEmailSent
              : root.dataset.successEmailDelayed;
          }
          if (success && !reducedMotion) {
            requestAnimationFrame(() => success.classList.add('is-entering'));
          }
          success?.focus();
        } catch (error) {
          if (transition) {
            transition.hidden = true;
            transition.classList.remove('is-completing');
          }
          if (fields) fields.hidden = false;
          if (errorMessage) {
            errorMessage.textContent = error.message || fallbackError;
            errorMessage.hidden = false;
            errorMessage.focus?.();
          }
        } finally {
          form.removeAttribute('aria-busy');
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
            submitButton.textContent = submitButton.dataset.defaultLabel || submitButton.textContent;
          }
        }
      });

      if (success && !success.hidden) success.focus();
    };

    document.querySelectorAll('[data-tct-join]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-tct-join]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tct-learning-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tct-memory-gallery')) {
    customElements.define('tct-memory-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.track = this.querySelector('[data-memory-track]');
        this.items = Array.from(this.querySelectorAll('[data-memory-item]'));
        this.dots = Array.from(this.querySelectorAll('[data-memory-dot]'));
        this.current = this.querySelector('[data-memory-current]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.frame = null;

        if (!this.track || this.items.length === 0) return;

        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updateFromPosition();
          });
        };

        this.onKeydown = (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const currentIndex = this.dots.findIndex((dot) => dot.classList.contains('is-active'));
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextIndex = Math.min(Math.max(currentIndex + direction, 0), this.items.length - 1);
          this.goTo(nextIndex);
        };

        this.onBlockSelect = (event) => {
          const item = event.target.closest('[data-memory-item]');
          if (!item || !this.contains(item)) return;
          this.goTo(this.items.indexOf(item));
        };

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('keydown', this.onKeydown);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));

        this.resizeObserver = new ResizeObserver(() => this.updateFromPosition());
        this.resizeObserver.observe(this.track);
        this.setActive(0);
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.track.removeEventListener('scroll', this.onScroll);
        this.track.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      goTo(index) {
        const item = this.items[index];
        if (!item) return;
        const trackRect = this.track.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const left = this.track.scrollLeft + itemRect.left - trackRect.left;
        this.track.scrollTo({ left, behavior: this.reducedMotion ? 'auto' : 'smooth' });
        this.setActive(index);
      }

      updateFromPosition() {
        const trackLeft = this.track.getBoundingClientRect().left;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;
        this.items.forEach((item, index) => {
          const distance = Math.abs(item.getBoundingClientRect().left - trackLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        this.setActive(closestIndex);
      }

      setActive(index) {
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (this.current) this.current.textContent = String(index + 1).padStart(2, '0');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tct-movement-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tct-movement')) {
    customElements.define('tct-movement', class extends HTMLElement {
      connectedCallback() {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const revealItems = Array.from(this.querySelectorAll('[data-movement-reveal]'));

        if (reducedMotion || !('IntersectionObserver' in window)) {
          revealItems.forEach((item) => item.classList.add('is-visible'));
          return;
        }

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          });
        }, { threshold: 0.14 });

        revealItems.forEach((item) => this.observer.observe(item));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tct-preorder-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tct-preorder-popup')) {
    customElements.define(
      'tct-preorder-popup',
      class TctPreorderPopup extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          if (!this.dialog || this.dataset.ready === 'true') return;

          this.dataset.ready = 'true';
          this.storageKey = `tct-preorder-popup-${this.dataset.sectionId}`;
          this.frequency = this.dataset.frequency || '7_days';
          this.opened = false;
          this.onScroll = this.onScroll.bind(this);
          this.onExit = this.onExit.bind(this);
          this.onSectionSelect = this.onSectionSelect.bind(this);
          this.onSectionDeselect = this.onSectionDeselect.bind(this);
          this.startCountdown();

          this.querySelectorAll('[data-tct-popup-close]').forEach((button) => {
            button.addEventListener('click', () => this.close());
          });

          this.querySelector('[data-tct-popup-primary]')?.addEventListener('click', () => this.recordDismissal());
          this.dialog.addEventListener('cancel', () => this.recordDismissal());
          this.dialog.addEventListener('close', () => {
            document.documentElement.style.removeProperty('overflow');
          });

          if (this.dataset.designMode === 'true') {
            document.addEventListener('shopify:section:select', this.onSectionSelect);
            document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
            return;
          }

          if (!this.matchesDevice() || !this.isWithinActiveWindow()) return;

          if (this.querySelector('[data-popup-form-success]')) {
            this.open();
            return;
          }

          if (this.wasRecentlyDismissed()) return;

          const delay = Math.max(0, Number(this.dataset.delay || 0)) * 1000;
          this.delayTimer = window.setTimeout(() => this.open(), delay);

          if (Number(this.dataset.scroll || 0) > 0) {
            window.addEventListener('scroll', this.onScroll, { passive: true });
          }

          if (this.dataset.exitIntent === 'true') {
            document.addEventListener('mouseout', this.onExit);
          }
        }

        disconnectedCallback() {
          window.clearTimeout(this.delayTimer);
          window.clearInterval(this.countdownTimer);
          window.removeEventListener('scroll', this.onScroll);
          document.removeEventListener('mouseout', this.onExit);
          document.removeEventListener('shopify:section:select', this.onSectionSelect);
          document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
        }

        matchesDevice() {
          const devices = this.dataset.devices || 'all';
          if (devices === 'all') return true;
          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          return devices === 'mobile' ? isMobile : !isMobile;
        }

        isWithinActiveWindow() {
          const now = Date.now();
          const start = Date.parse(this.dataset.activeFrom || '');
          const end = Date.parse(this.dataset.activeUntil || '');
          if (!Number.isNaN(start) && now < start) return false;
          if (!Number.isNaN(end) && now > end) return false;
          return true;
        }

        startCountdown() {
          this.countdown = this.querySelector('[data-tct-countdown]');
          if (!this.countdown) return;

          this.countdownTarget = Date.parse(this.countdown.dataset.deadline || '');
          if (Number.isNaN(this.countdownTarget)) {
            this.countdown.hidden = true;
            return;
          }

          this.updateCountdown();
          this.countdownTimer = window.setInterval(() => this.updateCountdown(), 1000);
        }

        updateCountdown() {
          if (!this.countdown) return;
          const remaining = Math.max(0, this.countdownTarget - Date.now());
          const days = Math.floor(remaining / 86400000);
          const hours = Math.floor((remaining % 86400000) / 3600000);
          const minutes = Math.floor((remaining % 3600000) / 60000);
          const seconds = Math.floor((remaining % 60000) / 1000);

          this.countdown.querySelector('[data-countdown-days]').textContent = String(days).padStart(2, '0');
          this.countdown.querySelector('[data-countdown-hours]').textContent = String(hours).padStart(2, '0');
          this.countdown.querySelector('[data-countdown-minutes]').textContent = String(minutes).padStart(2, '0');
          this.countdown.querySelector('[data-countdown-seconds]').textContent = String(seconds).padStart(2, '0');

          if (remaining > 0) return;
          window.clearInterval(this.countdownTimer);
          this.countdown.querySelector('.tct-preorder-popup__countdown-units').hidden = true;
          const expiredMessage = this.countdown.querySelector('[data-countdown-expired]');
          expiredMessage.textContent = this.countdown.dataset.expired || '';
          expiredMessage.hidden = false;
        }

        wasRecentlyDismissed() {
          if (this.frequency === 'always') return false;
          if (this.frequency === 'session') return sessionStorage.getItem(this.storageKey) === 'dismissed';

          const dismissedAt = Number(localStorage.getItem(this.storageKey));
          if (!dismissedAt) return false;

          const days = Number(this.frequency.replace('_days', '')) || 7;
          return Date.now() - dismissedAt < days * 86400000;
        }

        recordDismissal() {
          if (this.frequency === 'session') {
            sessionStorage.setItem(this.storageKey, 'dismissed');
          } else if (this.frequency !== 'always') {
            localStorage.setItem(this.storageKey, String(Date.now()));
          }
        }

        open() {
          if (this.opened || this.dialog.open) return;
          this.opened = true;
          window.clearTimeout(this.delayTimer);
          window.removeEventListener('scroll', this.onScroll);
          document.removeEventListener('mouseout', this.onExit);
          document.documentElement.style.overflow = 'hidden';
          this.dialog.showModal();
        }

        close() {
          this.recordDismissal();
          this.opened = false;
          if (this.dialog.open) this.dialog.close();
        }

        onScroll() {
          const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
          if (documentHeight <= 0) return;
          const progress = (window.scrollY / documentHeight) * 100;
          if (progress >= Number(this.dataset.scroll || 0)) this.open();
        }

        onExit(event) {
          if (window.innerWidth < 990) return;
          if (event.clientY <= 0 && !event.relatedTarget) this.open();
        }

        onSectionSelect(event) {
          if (event.detail.sectionId === this.dataset.sectionId) this.open();
        }

        onSectionDeselect(event) {
          if (event.detail.sectionId === this.dataset.sectionId && this.dialog.open) this.dialog.close();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tct-sticky-pack-cta"] && !Shopify.designMode) return;
  try {
    
  class TctStickyPackCta extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-tct-sticky-config]')?.textContent || '{}');
      this.action = this.querySelector('[data-tct-sticky-action]');
      this.eyebrow = this.querySelector('[data-tct-sticky-eyebrow]');
      this.prefixLabel = this.querySelector('[data-tct-sticky-prefix]');
      this.price = this.querySelector('[data-tct-sticky-price-value]');
      this.note = this.querySelector('[data-tct-sticky-note]');
      this.buttonLabel = this.querySelector('[data-tct-sticky-button-label]');
      this.offerTarget = this.dataset.offerTarget || '#packs-oferta';
      this.minScroll = Number(this.dataset.minScroll || 120);
      this.explicitSelection = false;
      this.intersections = new Map();
      this.initialViewportHeight = window.visualViewport?.height || window.innerHeight;
      this.handleAction = this.handleAction.bind(this);
      this.handleOfferSelection = this.handleOfferSelection.bind(this);
      this.handleViewportChange = this.handleViewportChange.bind(this);
      this.handleFocusChange = this.handleFocusChange.bind(this);
      this.refreshVisibility = this.refreshVisibility.bind(this);
      this.action?.addEventListener('click', this.handleAction);
      document.addEventListener('tct:offer-selected', this.handleOfferSelection);
      window.addEventListener('scroll', this.refreshVisibility, { passive: true });
      window.addEventListener('resize', this.handleViewportChange, { passive: true });
      window.visualViewport?.addEventListener('resize', this.handleViewportChange, { passive: true });
      document.addEventListener('focusin', this.handleFocusChange);
      document.addEventListener('focusout', this.handleFocusChange);
      this.observeConversionTargets();
      this.refreshVisibility();
    }

    disconnectedCallback() {
      this.action?.removeEventListener('click', this.handleAction);
      document.removeEventListener('tct:offer-selected', this.handleOfferSelection);
      window.removeEventListener('scroll', this.refreshVisibility);
      window.removeEventListener('resize', this.handleViewportChange);
      window.visualViewport?.removeEventListener('resize', this.handleViewportChange);
      document.removeEventListener('focusin', this.handleFocusChange);
      document.removeEventListener('focusout', this.handleFocusChange);
      this.observer?.disconnect();
    }

    observeConversionTargets() {
      this.observer?.disconnect();
      this.intersections.clear();
      const selectors = [
        this.offerTarget,
        'tct-offer-selector',
        'a[href="#packs-oferta"]',
        '.product-form__buttons',
        '.shopify-payment-button',
        '[data-testid="tct-offer-add-to-cart"]'
      ];
      const targets = Array.from(document.querySelectorAll(selectors.join(','))).filter((element) => !this.contains(element));
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => this.intersections.set(entry.target, entry.isIntersecting && entry.intersectionRatio > 0));
        this.refreshVisibility();
      }, { threshold: [0, 0.01, 0.5] });
      targets.forEach((target) => {
        this.intersections.set(target, false);
        this.observer.observe(target);
      });
    }

    handleOfferSelection(event) {
      const detail = event.detail || {};
      if (!detail.pack || !detail.price) return;
      this.explicitSelection = true;
      this.eyebrow.textContent = [detail.pack, detail.nights].filter(Boolean).join(' · ');
      this.prefixLabel.textContent = '';
      this.price.textContent = detail.price;
      this.note.textContent = detail.note ? `· ${detail.note}` : '';
      this.note.hidden = !detail.note;
      this.buttonLabel.textContent = this.config.selectedButton || 'RESERVAR AHORA';
      this.refreshVisibility();
    }

    handleAction() {
      const offer = document.querySelector('tct-offer-selector');
      const purchaseButton = offer?.closest('form')?.querySelector('[data-testid="tct-offer-add-to-cart"]');
      if (this.explicitSelection && purchaseButton && !purchaseButton.disabled) {
        this.setVisible(false);
        purchaseButton.click();
        window.setTimeout(this.refreshVisibility, 800);
        return;
      }
      const target = document.querySelector(this.offerTarget) || offer;
      target?.scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'start' });
    }

    handleViewportChange() {
      const currentHeight = window.visualViewport?.height || window.innerHeight;
      this.keyboardOpen = this.initialViewportHeight - currentHeight > 120;
      if (!this.keyboardOpen && currentHeight > this.initialViewportHeight) this.initialViewportHeight = currentHeight;
      this.refreshVisibility();
    }

    handleFocusChange() {
      window.requestAnimationFrame(this.refreshVisibility);
    }

    get reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    get interfaceBusy() {
      const active = document.activeElement;
      const typing = active?.matches('input:not([type="radio"]):not([type="checkbox"]), textarea, select, [contenteditable="true"]');
      const modal = Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], cart-drawer[open], [data-cart-drawer][aria-hidden="false"]')).some((element) => {
        const style = window.getComputedStyle(element);
        return style.display !== 'none' && style.visibility !== 'hidden';
      });
      return Boolean(this.keyboardOpen || typing || modal);
    }

    refreshVisibility() {
      const conversionVisible = Array.from(this.intersections.values()).some(Boolean);
      const shouldShow = window.scrollY >= this.minScroll && !conversionVisible && !this.interfaceBusy;
      this.setVisible(shouldShow);
    }

    setVisible(visible) {
      this.classList.toggle('is-visible', visible);
      this.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (this.action) this.action.tabIndex = visible ? 0 : -1;
    }
  }

  if (!customElements.get('tct-sticky-pack-cta')) {
    customElements.define('tct-sticky-pack-cta', TctStickyPackCta);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tct-story-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tct-story')) {
    customElements.define('tct-story', class TctStory extends HTMLElement {
      connectedCallback() {
        this.progressText = this.querySelector('[data-story-progress-text]');
        this.timeline = this.querySelector('.tct-story__timeline');
        this.storyEntries = [...this.querySelectorAll('.tct-story__entry')];
        this.reveals = [...this.querySelectorAll('[data-story-reveal]')];
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.updateProgress = this.updateProgress.bind(this);
        this.scheduleProgress = this.scheduleProgress.bind(this);

        if (this.reducedMotion || !('IntersectionObserver' in window)) {
          this.reveals.forEach((element) => element.classList.add('is-visible'));
        } else {
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                this.observer.unobserve(entry.target);
              }
            });
          }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
          this.reveals.forEach((element) => this.observer.observe(element));
        }

        this.updateProgress();
        window.addEventListener('scroll', this.scheduleProgress, { passive: true });
        window.addEventListener('resize', this.scheduleProgress, { passive: true });
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.scheduleProgress);
        window.removeEventListener('resize', this.scheduleProgress);
        if (this.progressFrame) cancelAnimationFrame(this.progressFrame);
        if (this.observer) this.observer.disconnect();
      }

      scheduleProgress() {
        if (this.progressFrame) return;
        this.progressFrame = requestAnimationFrame(() => {
          this.progressFrame = null;
          this.updateProgress();
        });
      }

      updateProgress() {
        if (!this.timeline) return;
        const rect = this.timeline.getBoundingClientRect();
        const range = rect.height + window.innerHeight;
        const progress = Math.max(0, Math.min(1, (window.innerHeight - rect.top) / range));
        this.style.setProperty('--story-progress', progress.toFixed(4));
        this.dataset.fireStage = progress < 0.28 ? 'ember' : progress < 0.68 ? 'warm' : progress < 0.92 ? 'alive' : 'gold';
        const fireY = window.innerHeight * (window.innerWidth < 900 ? 0.42 : 0.44);
        let activeEntry;
        let closestDistance = Infinity;
        this.storyEntries.forEach((entry) => {
          const entryRect = entry.getBoundingClientRect();
          const distance = fireY < entryRect.top
            ? entryRect.top - fireY
            : fireY > entryRect.bottom
              ? fireY - entryRect.bottom
              : 0;
          if (distance < closestDistance) {
            closestDistance = distance;
            activeEntry = entry;
          }
        });
        this.dataset.fireTone = activeEntry && activeEntry.classList.contains('tct-story__entry--graphite')
          ? 'graphite'
          : activeEntry && activeEntry.classList.contains('tct-story__entry--mist')
            ? 'mist'
            : 'paper';
        if (this.progressText) this.progressText.textContent = `${Math.round(progress * 100)}%`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
